import React, { memo } from 'react';
import Style from './styles.module.scss';

const EntitlementInfo = () => (
  <div className={Style.entitlementInfo}>
    <div className={Style.partnerTitle}>
      ĐỐI TÁC
      <br />
      VIỆC LÀM TỐT
    </div>
    <div className={Style.textLayout}>
      <div className={Style.icTrusted} />
      <div className={Style.text}>Việc làm xác thực</div>
    </div>
    <div className={Style.textLayout}>
      <div className={Style.icTrusted} />
      <div className={Style.text}>Phản hồi trong 7 ngày</div>
    </div>
  </div>
);

EntitlementInfo.defaultProps = {};

EntitlementInfo.propTypes = {};

export default memo(EntitlementInfo);
